import { useState } from 'react';
import { editorStore } from '../../stores/editorStore';
import { BUILDING_BLOCKS } from '../../types';

/** 资源库分类 */
const TABS = [
  { key: 'all', label: '全部' },
  { key: 'character', label: '角色' },
  { key: 'prop', label: '道具' },
  { key: 'background', label: '背景' },
  { key: 'decoration', label: '装饰' },
];

/**
 * 左侧资源库：场景积木、导入图片、空白元素
 * 点击积木 = 添加对应分类的元素到当前页
 */
export function LibraryPanel() {
  const [tab, setTab] = useState('all');
  const addElement = editorStore((s) => s.addElement);
  const addText = editorStore((s) => s.addText);
  const currentPage = editorStore((s) =>
    s.book?.pages.find((p) => p.id === s.currentPageId) ?? null
  );

  const blocks = BUILDING_BLOCKS.filter(
    (b) => tab === 'all' || b.category === tab
  );

  return (
    <aside className="editor-library editor-panel">
      <div className="editor-panel-header">
        <span className="editor-panel-title">资源库</span>
        <span className="editor-panel-sub">{currentPage?.title ?? '-'}</span>
      </div>

      <div className="editor-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={`editor-tab${tab === t.key ? ' editor-tab-active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="editor-library-grid">
        {blocks.map((b) => (
          <button
            key={b.name}
            className="editor-library-card"
            onClick={() => {
              if (b.category === 'text') {
                addText();
              } else {
                addElement(b.category, b.label);
              }
            }}
          >
            <div className={`editor-library-emoji editor-emoji-${b.category}`}>
              {b.category === 'character' ? '🧸' : b.category === 'prop' ? '🌙' : b.category === 'background' ? '☁️' : '🌼'}
            </div>
            <span className="editor-library-name">{b.label}</span>
            <span className="editor-library-desc">{b.description}</span>
          </button>
        ))}
      </div>

      <div className="editor-library-actions">
        <button className="editor-primary-btn" onClick={() => addElement('prop', '空白元素')}>
          + 空白元素
        </button>
        <label className="editor-upload-btn">
          导入图片
          <input type="file" accept="image/*" style={{ display: 'none' }} />
        </label>
        <ImportPipelineButton />
      </div>

      <div className="editor-library-hint">
        拖拽到画布后可在右侧设置位置、叙事属性与交互
      </div>
    </aside>
  );
}

/** 导入 AI 分层结果按钮 */
function ImportPipelineButton() {
  const importPipelineResult = editorStore((s) => s.importPipelineResult);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const text = String(ev.target?.result ?? '');
        const json = JSON.parse(text);
        importPipelineResult(json);
        alert('AI 分层结果导入成功');
      } catch (err) {
        alert('JSON 解析失败：' + (err instanceof Error ? err.message : String(err)));
      }
    };
    reader.readAsText(file);

    // 清空 input，允许再次选择同一文件
    e.target.value = '';
  };

  return (
    <label className="editor-upload-btn">
      导入 AI 分层结果
      <input
        type="file"
        accept="application/json"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </label>
  );
}